export default __webpack_public_path__ + "static/media/01.2a982591.jpg";